import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rejected-info',
  templateUrl: './rejected-info.component.html',
  styleUrls: ['./rejected-info.component.scss']
})
export class RejectedInfoComponent {
  @Input() set detail(value) {
    if (value && value.verification) {
      this.info = value.verification;
    }
  };
  info: any = null;

  constructor() { }
}
